/*
 * Sticky Announcement Bar
 * 
 * This script makes the announcement bar sticky at the top of the page.
 * It works in conjunction with the existing sticky header functionality.
 */

class StickyAnnouncementBar {
  constructor() {
    // Elements
    this.announcementBar = document.querySelector('.announcement-bar-section');
    this.header = document.querySelector('.section-header');
    this.stickyHeader = document.querySelector('sticky-header');
    
    if (!this.announcementBar) return;
    
    // Measurements
    this.announcementBarHeight = this.announcementBar.offsetHeight;
    this.scrollThreshold = this.announcementBar.getBoundingClientRect().top + window.scrollY;
    
    // Initialize
    this.init();
  }
  
  init() {
    // Add necessary CSS variables
    document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBarHeight}px`);
    
    // Add event listeners
    window.addEventListener('scroll', this.handleScroll.bind(this));
    window.addEventListener('resize', this.handleResize.bind(this));
    
    // Initial state check
    this.handleScroll();
  }
  
  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    
    if (scrollTop > this.scrollThreshold) {
      this.announcementBar.classList.add('is-sticky');
      document.body.classList.add('has-sticky-announcement-bar');
      
      // Adjust header positioning when used with sticky header
      if (this.stickyHeader && this.stickyHeader.classList.contains('shopify-section-header-sticky')) {
        this.stickyHeader.style.top = `${this.announcementBarHeight}px`;
      }
    } else {
      this.announcementBar.classList.remove('is-sticky');
      document.body.classList.remove('has-sticky-announcement-bar');
      
      // Reset header positioning
      if (this.stickyHeader) {
        this.stickyHeader.style.top = '0';
      }
    }
  }
  
  handleResize() {
    // Recalculate heights on resize
    this.announcementBarHeight = this.announcementBar.offsetHeight;
    this.scrollThreshold = this.announcementBar.getBoundingClientRect().top + window.scrollY;
    document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBarHeight}px`);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new StickyAnnouncementBar();
});